module.exports = __webpack_public_path__ + "img/syukyaku-top-back001sp.4315830b.jpg";